/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Status
 * Enum which indicates the status of Visualization
 */
export enum CoreVisualizationVisualizationStatus {
  PartialSuccess = "partial_success",
  Creating = "creating",
  Success = "success",
  Failed = "failed",
}

/**
 * Status
 * Enum which indicates the status of Asset
 */
export enum CoreAssetAssetStatus {
  Started = "started",
  Creating = "creating",
  Success = "success",
  Failed = "failed",
}

/** VisualizationType */
export enum VisualizationType {
  Preset = "preset",
  Custom = "custom",
}

/** Type */
export enum Type {
  Custom = "custom",
  Preset = "preset",
}

/**
 * StatusEnum
 * Enum which indicates the status of AOI
 */
export enum StatusEnum {
  Started = "started",
  Running = "running",
  Success = "success",
  Failed = "failed",
  Updating = "updating",
  PartialSuccess = "partial_success",
}

/** SortOrder */
export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

/** SignatureType */
export enum SignatureType {
  Point = "point",
  Polygon = "polygon",
}

/**
 * MimeTypes
 * https://github.com/radiantearth/stac-spec/blob/v1.0.0/item-spec/item-spec.md#media-types
 */
export enum MimeTypes {
  ImageTiffApplicationGeotiff = "image/tiff; application=geotiff",
  ImageTiffApplicationGeotiffProfileCloudOptimized = "image/tiff; application=geotiff; profile=cloud-optimized",
  ImageJp2 = "image/jp2",
  ImagePng = "image/png",
  ImageJpeg = "image/jpeg",
  ApplicationGeoJson = "application/geo+json",
  ApplicationGeoJsonSeq = "application/geo+json-seq",
  ApplicationGeopackageSqlite3 = "application/geopackage+sqlite3",
  ApplicationVndGoogleEarthKmlXml = "application/vnd.google-earth.kml+xml",
  ApplicationVndGoogleEarthKmz = "application/vnd.google-earth.kmz",
  ApplicationXProtobuf = "application/x-protobuf",
  ApplicationVndMapboxVectorTile = "application/vnd.mapbox-vector-tile",
  ApplicationXHdf = "application/x-hdf",
  ApplicationXHdf5 = "application/x-hdf5",
  ApplicationXml = "application/xml",
  ApplicationJson = "application/json",
  ApplicationNdjson = "application/ndjson",
  TextHtml = "text/html",
  TextPlain = "text/plain",
  ApplicationVndOaiOpenapiJsonVersion30 = "application/vnd.oai.openapi+json;version=3.0",
  ApplicationVndOaiOpenapiVersion30 = "application/vnd.oai.openapi;version=3.0",
  ApplicationSchemaJson = "application/schema+json",
  ApplicationPdf = "application/pdf",
  TextCsv = "text/csv",
  ApplicationVndApacheParquet = "application/vnd.apache.parquet",
}

/** LayerType */
export enum LayerType {
  Single = "single",
  Index = "index",
  Indices = "indices",
  Composite = "composite",
  Grayscale = "grayscale",
}

/** ExpressionType */
export enum ExpressionType {
  Composite = "composite",
  Index = "index",
  Grayscale = "grayscale",
}

/** AssetType */
export enum AssetType {
  Mosaic = "mosaic",
  Tile = "tile",
  Layer = "layer",
  Visualization = "visualization",
  StacItem = "stac_item",
  Datacube = "datacube",
}

/**
 * AOICreateModel
 * AOICreateModel represents a write model to create a AOI.
 */
export interface AOICreateModel {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Polygon Model */
  geometry: Polygon;
  /** Lens Satellite Id */
  lens_satellite_id?: string | null;
  /** Tenant Id */
  tenant_id: string;
  /** Images */
  images: Record<string, any>;
  /**
   * Is Favourite
   * @default false
   */
  is_favourite?: boolean;
  /** Eo Bands */
  eo_bands: string[];
}

/**
 * AOICreateModelV2
 * AOICreateModelV2 represents a write model to create a AOI
 */
export interface AOICreateModelV2 {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Lens Satellite Id */
  lens_satellite_id: string;
  /** Provider */
  provider: string;
  /** Project Id */
  project_id: string;
  /** Polygon Model */
  geometry: Polygon;
  /** Item Ids */
  item_ids: string[];
}

/** AOIListResponseModel */
export interface AOIListResponseModel {
  /** Aois */
  aois: AOIReadModel[];
  pagination: PaginationModel;
}

/**
 * AOIReadModel
 * AOIReadModel represents data structure as a read aoi.
 */
export interface AOIReadModel {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Lens Satellite Id */
  lens_satellite_id?: string | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Images */
  images: Record<string, any>;
  /** Eo Bands */
  eo_bands: string[];
  /** Polygon Model */
  geometry: Polygon;
  /** Progress */
  progress: number;
  /** Enum which indicates the status of AOI */
  status: StatusEnum;
  /** Is Favourite */
  is_favourite: boolean;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  /** User Id */
  user_id: string;
  /** Area In Sq M */
  area_in_sq_m: number;
  /**
   * Centroid
   * @maxItems 2
   * @minItems 2
   */
  centroid: any[];
  /** Rgb Bands */
  rgb_bands: string[];
}

/**
 * AOIUpdateModel
 * AOIUpdateModel represents a write model to update a aoi.
 * Will add update support to other fields soon
 */
export interface AOIUpdateModel {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  /**
   * Is Favourite
   * @default false
   */
  is_favourite?: boolean | null;
  /** Images */
  images?: Record<string, any> | null;
}

/**
 * AOIUpdateModelV2
 * AOIUpdateModelV2 represents a write model to update a aoi with project_id.
 */
export interface AOIUpdateModelV2 {
  /**
   * Name
   * @example "AOI-Bangalore"
   */
  name: string | null;
  /**
   * Description
   * @example "This AOI contains images related to Bangalore"
   */
  description: string | null;
  /**
   * Is Favourite
   * @default false
   * @example false
   */
  is_favourite?: boolean | null;
  /**
   * Images
   * @example {"2021-11-06T17:35:31.024000Z":[{"lens_satellite_id":"0005sp5b-0td2-4c80-9393-4a808341c54c","provider":"aws","url":"stac_url"}],"2022-11-06T17:35:31.024000Z":[{"lens_satellite_id":"0005sp5b-0td2-4c80-9393-4a808341c54c","provider":"planetary","url":"stac_url"},{"lens_satellite_id":"0005sp5b-0td2-4c80-9393-4a808341c54c","provider":"aws","url":"stac_url"}]}
   */
  images: Record<string, any> | null;
  /**
   * Project Id
   * @example "ce5dcc14-8291-4b0c-a278-8c05ec426d16"
   */
  project_id: string;
}

/**
 * Asset
 * https://github.com/radiantearth/stac-spec/blob/v1.0.0/item-spec/item-spec.md#asset-object
 */
export interface Asset {
  /**
   * Href
   * @minLength 1
   */
  href: string;
  /** Type */
  type?: string | null;
  /** Title */
  title?: string | null;
  /** Description */
  description?: string | null;
  /** Roles */
  roles?: string[] | null;
  [key: string]: any;
}

/**
 * AssetDownloadModel
 * AssetDownloadModel represents a data model to download an asset.
 */
export interface AssetDownloadModel {
  /** File Name */
  file_name: string;
  /** File Path */
  file_path: string;
}

/** AssetListResponseModel */
export interface AssetListResponseModel {
  /** Assets */
  assets: AssetReadModel[];
  pagination: PaginationModel;
}

/**
 * AssetReadModel
 * AssetReadModel represents data structure as a read model.
 */
export interface AssetReadModel {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Aoi Id
   * @format uuid
   */
  aoi_id: string;
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Path */
  path: string;
  /** Progress */
  progress: number;
  /** Enum which indicates the status of Asset */
  status: CoreAssetAssetStatus;
  asset_type: AssetType;
  /** Band List */
  band_list: any[];
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  /** Geometry */
  geometry?: Record<string, any> | null;
  /** Area In Sq M */
  area_in_sq_m: number;
  /** Visualization Id */
  visualization_id?: string | null;
  /** Date */
  date: string;
  /** Centroid */
  centroid?: any[] | null;
  /** Resolution */
  resolution?: number | null;
}

/** BaseModel */
export type BaseModel = object;

/** Body_convert_geometry_file_geometry_post */
export interface BodyConvertGeometryFileGeometryPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** DownloadCreateModel */
export interface DownloadCreateModel {
  /** Asset Ids */
  asset_ids: string[];
}

/** DownloadReadModel */
export interface DownloadReadModel {
  /** Download Id */
  download_id: string;
  /** Status */
  status: string;
  /** Signed Url */
  signed_url?: string | null;
}

/** Error */
export interface Error {
  /** Code */
  code: string;
  /** Message */
  message: string;
}

/** ErrorMessageAOIAlreadyExists */
export interface ErrorMessageAOIAlreadyExists {
  /** Detail */
  detail: string;
}

/** ErrorMessageAOINotFound */
export interface ErrorMessageAOINotFound {
  /** Detail */
  detail: string;
}

/** ErrorMessageAssetNotFound */
export interface ErrorMessageAssetNotFound {
  /** Detail */
  detail: string;
}

/** ErrorMessageIndexAlreadyExists */
export interface ErrorMessageIndexAlreadyExists {
  /** Detail */
  detail: string;
}

/** ErrorMessageIndexNotFound */
export interface ErrorMessageIndexNotFound {
  /** Detail */
  detail: string;
}

/** ErrorMessageIndicesNotFound */
export interface ErrorMessageIndicesNotFound {
  /** Detail */
  detail: string;
}

/** ErrorMessageLayerAlreadyExists */
export interface ErrorMessageLayerAlreadyExists {
  /** Detail */
  detail: string;
}

/** ErrorMessageLayerNotFound */
export interface ErrorMessageLayerNotFound {
  /** Detail */
  detail: string;
}

/** ErrorSchema */
export interface ErrorSchema {
  error: Error;
}

/**
 * Feature
 * Feature Model
 */
export interface Feature {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "Feature";
  /** Geometry */
  geometry:
    | (
        | ({
            type: "GeometryCollection";
          } & GeometryCollection)
        | ({
            type: "LineString";
          } & LineString)
        | ({
            type: "MultiLineString";
          } & MultiLineString)
        | ({
            type: "MultiPoint";
          } & MultiPoint)
        | ({
            type: "MultiPolygon";
          } & MultiPolygon)
        | ({
            type: "Point";
          } & Point)
        | ({
            type: "Polygon";
          } & Polygon)
      )
    | null;
  /** Properties */
  properties: Record<string, any> | BaseModel | null;
  /** Id */
  id?: number | string | null;
}

/**
 * FeatureCollection
 * FeatureCollection Model
 */
export interface FeatureCollection {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "FeatureCollection";
  /** Features */
  features: Feature[];
}

/** Filter */
export interface Filter {
  /** Name */
  name: string;
  /** Operator */
  operator: string;
  /** Value */
  value?: null;
}

/**
 * GeometryCollection
 * GeometryCollection Model
 */
export interface GeometryCollection {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "GeometryCollection";
  /** Geometries */
  geometries: (
    | ({
        type: "GeometryCollection";
      } & GeometryCollection)
    | ({
        type: "LineString";
      } & LineString)
    | ({
        type: "MultiLineString";
      } & MultiLineString)
    | ({
        type: "MultiPoint";
      } & MultiPoint)
    | ({
        type: "MultiPolygon";
      } & MultiPolygon)
    | ({
        type: "Point";
      } & Point)
    | ({
        type: "Polygon";
      } & Polygon)
  )[];
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** IndexCreateModel */
export interface IndexCreateModel {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Rescale */
  rescale: any[];
  /** Expression */
  expression: string;
  /** Colormap */
  colormap: string;
  /** Lens Satellite Id */
  lens_satellite_id: string;
  expression_type: ExpressionType;
}

/** IndexCreateModelV1 */
export interface IndexCreateModelV1 {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Title */
  title?: string | null;
  /** Rescale */
  rescale: any[];
  /** Expression */
  expression: string;
  /** Colormap */
  colormap: string;
  /** Lens Satellite Id */
  lens_satellite_id?: string | null;
  type: ExpressionType;
}

/** IndexReadModel */
export interface IndexReadModel {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Title */
  title?: string | null;
  /** Lens Satellite Id */
  lens_satellite_id?: string | null;
  /** Colormap */
  colormap: string;
  /** Rescale */
  rescale: any[];
  /** Expression */
  expression: string;
  expression_type: ExpressionType;
  type: Type;
  /** Bands */
  bands?: string[] | null;
  /** Thumbnail Url */
  thumbnail_url: string | null;
  /** Bins Colormap */
  bins_colormap?: string[] | null;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
}

/** IndexReadModelV1 */
export interface IndexReadModelV1 {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Title */
  title?: string | null;
  /** Lens Satellite Id */
  lens_satellite_id?: string | null;
  /** Colormap */
  colormap: string;
  /** Rescale */
  rescale: any[];
  /** Expression */
  expression: string;
  type: ExpressionType;
  /** Bands */
  bands?: string[] | null;
  /** Thumbnail Url */
  thumbnail_url?: string | null;
  /** Bins Colormap */
  bins_colormap?: string[] | null;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
}

/** IndicesListResponseModel */
export interface IndicesListResponseModel {
  /** Indices */
  indices: IndexReadModel[];
  pagination: PaginationModel;
}

/**
 * Item
 * https://github.com/radiantearth/stac-spec/blob/v1.0.0/item-spec/item-spec.md
 */
export interface Item {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "Feature";
  /** Geometry */
  geometry:
    | (
        | ({
            type: "GeometryCollection";
          } & GeometryCollection)
        | ({
            type: "LineString";
          } & LineString)
        | ({
            type: "MultiLineString";
          } & MultiLineString)
        | ({
            type: "MultiPoint";
          } & MultiPoint)
        | ({
            type: "MultiPolygon";
          } & MultiPolygon)
        | ({
            type: "Point";
          } & Point)
        | ({
            type: "Polygon";
          } & Polygon)
      )
    | null;
  /** https://github.com/radiantearth/stac-spec/blob/v1.0.0/item-spec/item-spec.md#properties-object */
  properties: ItemProperties;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Stac Version
   * @default "1.0.0"
   * @pattern ^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$
   */
  stac_version?: string;
  /** Assets */
  assets: Record<string, Asset>;
  links: Links;
  /**
   * Stac Extensions
   * @default []
   */
  stac_extensions?: string[] | null;
  /** Collection */
  collection?: string | null;
}

/**
 * ItemProperties
 * https://github.com/radiantearth/stac-spec/blob/v1.0.0/item-spec/item-spec.md#properties-object
 */
export interface ItemProperties {
  /** Title */
  title?: string | null;
  /** Description */
  description?: string | null;
  /** Datetime */
  datetime: string | null;
  /** Created */
  created?: string | null;
  /** Updated */
  updated?: string | null;
  /** Start Datetime */
  start_datetime?: string | null;
  /** End Datetime */
  end_datetime?: string | null;
  /** License */
  license?: string | null;
  /** Providers */
  providers?: Provider[] | null;
  /** Platform */
  platform?: string | null;
  /** Instruments */
  instruments?: string[] | null;
  /** Constellation */
  constellation?: string | null;
  /** Mission */
  mission?: string | null;
  /** Gsd */
  gsd?: number | null;
  [key: string]: any;
}

/**
 * LayerCreateModel
 * LayerCreateModel represents write model to create layer entity
 */
export interface LayerCreateModel {
  /** Name */
  name: string;
  layer_type: LayerType;
  /** Preview Url */
  preview_url: string;
  /** Bands */
  bands: string[];
  /** Expression */
  expression: string;
}

/**
 * LayerGenerateModel
 * LayerGenerateModel represents a write model to create layer entity and generate a
 */
export interface LayerGenerateModel {
  /** Name */
  name: string;
  layer_type: LayerType;
  /** Preview Url */
  preview_url: string;
  /** Bands */
  bands: string[];
  /** Expression */
  expression: string;
  /** Date */
  date: string;
}

/**
 * LayerReadModel
 * LayerReadModel represents data structure as a read model.
 */
export interface LayerReadModel {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  layer_type: LayerType;
  /**
   * Aoi Id
   * @format uuid
   */
  aoi_id: string;
  /** Preview Url */
  preview_url: string;
  /** Bands */
  bands: string[];
  /** Expression */
  expression: string;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
}

/**
 * LayerUpdateModel
 * LayerUpdateModel represents write model to update layer entity
 */
export interface LayerUpdateModel {
  /** Name */
  name?: string | null;
  /** Bands */
  bands?: string[] | null;
  /** Preview Url */
  preview_url?: string | null;
  /** Expression */
  expression?: string | null;
}

/** LegendItem */
export interface LegendItem {
  /**
   * Min
   * @example 0
   */
  min: number;
  /**
   * Max
   * @example 51
   */
  max: number;
  /**
   * Color
   * @example "#2b83ba"
   */
  color: string;
  /**
   * Label
   * @example "Very Low"
   */
  label: string;
  /**
   * Area
   * @example 50
   */
  area: number;
  /**
   * Percentage
   * @example 5
   */
  percentage: number;
}

/**
 * LineString
 * LineString Model
 */
export interface LineString {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "LineString";
  /**
   * Coordinates
   * @minItems 2
   */
  coordinates: (Position2D | Position3D)[];
}

/**
 * Link
 * https://github.com/radiantearth/stac-spec/blob/v1.0.0/collection-spec/collection-spec.md#link-object
 */
export interface Link {
  /**
   * Href
   * @minLength 1
   */
  href: string;
  /**
   * Rel
   * @minLength 1
   */
  rel: string;
  type?: MimeTypes | null;
  /** Title */
  title?: string | null;
  /** Label:Assets */
  "label:assets"?: string | null;
  [key: string]: any;
}

/** Links */
export type Links = Link[];

/** ListSignatureModel */
export interface ListSignatureModel {
  /**
   * Signatures
   * @example [{"aoi_id":"random_aoi_id","created_at":"2024-10-15T15:34:11.870837","created_by":"6a7f97bc-2d65-4345-b162-311ac6268374","id":"signature_id","name":"redmond forest","type":"Point","updated_at":"2024-10-15T15:34:11.870837","updated_by":"7da62bd9-8cf6-46f6-8204-a58080e0fa8a"},{"aoi_id":"random_aoi_id","created_at":"2024-10-15T15:34:11.870837","created_by":"6a7f97bc-2d65-4345-b162-311ac6268374","id":"signature_id2","name":"redmond lake","type":"Polygon","updated_at":"2024-10-15T15:34:11.870837","updated_by":"7da62bd9-8cf6-46f6-8204-a58080e0fa8a"}]
   */
  signatures: SignatureModel[];
}

/**
 * MultiLineString
 * MultiLineString Model
 */
export interface MultiLineString {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "MultiLineString";
  /** Coordinates */
  coordinates: (Position2D | Position3D)[][];
}

/**
 * MultiPoint
 * MultiPoint Model
 */
export interface MultiPoint {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "MultiPoint";
  /** Coordinates */
  coordinates: (Position2D | Position3D)[];
}

/**
 * MultiPolygon
 * MultiPolygon Model
 */
export interface MultiPolygon {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "MultiPolygon";
  /** Coordinates */
  coordinates: (Position2D | Position3D)[][][];
}

/** PaginationModel */
export interface PaginationModel {
  /** Total */
  total: number;
  /** Offset */
  offset: number;
  /** Limit */
  limit: number;
}

/**
 * Point
 * Point Model
 */
export interface Point {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "Point";
  /** Coordinates */
  coordinates: Position2D | Position3D;
}

/**
 * Polygon
 * Polygon Model
 */
export interface Polygon {
  /** Bbox */
  bbox?: any[] | null;
  /** Type */
  type: "Polygon";
  /** Coordinates */
  coordinates: (Position2D | Position3D)[][];
}

/**
 * @maxItems 2
 * @minItems 2
 */
export type Position2D = any[];

/**
 * @maxItems 3
 * @minItems 3
 */
export type Position3D = any[];

/**
 * Provider
 * https://github.com/radiantearth/stac-spec/blob/v1.0.0/collection-spec/collection-spec.md#provider-object
 */
export interface Provider {
  /**
   * Name
   * @minLength 1
   */
  name: string;
  /** Description */
  description?: string | null;
  /** Roles */
  roles?: string[] | null;
  /** Url */
  url?: string | null;
}

/**
 * RQLQuery
 * @example {"filters":[{"name":"status","operator":"eq","value":"active"},{"name":"created_at","operator":"gte","value":"2024-01-01T00:00:00Z"}],"limit":50,"offset":0,"sort":[{"name":"created_at","order":"desc"}]}
 */
export interface RQLQuery {
  /** Filters */
  filters?: Filter[];
  /**
   * Offset
   * @min 0
   * @default 0
   */
  offset?: number;
  /** Limit */
  limit?: number | null;
  /** Sort */
  sort?: Sort[];
  /** Search */
  search?: string | null;
}

/** SignatureCreateModel */
export interface SignatureCreateModel {
  /**
   * Aoi Id
   * @example "c936fd53-7d58-4db7-ba90-1778e530f6d9"
   */
  aoi_id: string;
  /**
   * Name
   * @example "Redmond"
   */
  name: string;
  /**
   * FeatureCollection Model
   * @example {"features":[{"geometry":{"coordinates":[76.65938195391948,21.942292968927006],"type":"Point"},"properties":{"name":"Point 1"},"type":"Feature"}],"type":"FeatureCollection"}
   */
  features: FeatureCollection;
  /** @example "Point" */
  type: SignatureType;
  /** Graphs */
  graphs: SpectralGraph[];
}

/** SignatureDetailModel */
export interface SignatureDetailModel {
  /**
   * Id
   * @example "22a6e18e-f3b9-4aef-b142-c516251e7dda"
   */
  id: string;
  /**
   * Aoi Id
   * @example "c936fd53-7d58-4db7-ba90-1778e530f6d9"
   */
  aoi_id: string;
  /**
   * Name
   * @example "Redmond"
   */
  name: string;
  /**
   * FeatureCollection Model
   * @example {"features":[{"geometry":{"coordinates":[76.65938195391948,21.942292968927006],"type":"Point"},"properties":{"name":"Point 1"},"type":"Feature"}],"type":"FeatureCollection"}
   */
  features: FeatureCollection;
  /** @example "Point" */
  type: SignatureType;
  /**
   * Graphs
   * @example [{"2023-12-30":{"B01":1466,"B02":1644,"B03":1284,"B04":280,"B05":282,"B06":249,"B07":253,"B08":226,"B09":258,"B11":243,"B12":229,"B8A":270,"SCL":6}}]
   */
  graphs: SpectralGraph[];
  /**
   * Created By
   * @example "6a7f97bc-2d65-4345-b162-311ac6268374"
   */
  created_by: string;
  /**
   * Updated By
   * @example "7da62bd9-8cf6-46f6-8204-a58080e0fa8a"
   */
  updated_by: string;
  /**
   * Created At
   * @format date
   * @example "2024-10-15T15:34:11.870837"
   */
  created_at: string;
  /**
   * Updated At
   * @format date
   * @example "2024-10-15T15:34:11.870837"
   */
  updated_at: string;
}

/** SignatureModel */
export interface SignatureModel {
  /**
   * Id
   * @example "22a6e18e-f3b9-4aef-b142-c516251e7dda"
   */
  id: string;
  /**
   * Aoi Id
   * @example "c936fd53-7d58-4db7-ba90-1778e530f6d9"
   */
  aoi_id: string;
  /**
   * Name
   * @example "Redmond"
   */
  name: string;
  /** @example "Point" */
  type: SignatureType;
  /**
   * Created By
   * @example "6a7f97bc-2d65-4345-b162-311ac6268374"
   */
  created_by: string;
  /**
   * Updated By
   * @example "7da62bd9-8cf6-46f6-8204-a58080e0fa8a"
   */
  updated_by: string;
  /**
   * Created At
   * @format date
   * @example "2024-10-15T15:34:11.870837"
   */
  created_at: string;
  /**
   * Updated At
   * @format date
   * @example "2024-10-15T15:34:11.870837"
   */
  updated_at: string;
}

/**
 * SignatureReadModel
 * SignatureReadModel represents data structure as a read model.
 */
export interface SignatureReadModel {
  /** Point Model */
  point: Point;
  /** Results */
  results: Record<string, any>;
}

/** SignatureUpdateModel */
export interface SignatureUpdateModel {
  /**
   * Name
   * @example "Redmond"
   */
  name: string | null;
  /**
   * FeatureCollection Model
   * @example {"features":[{"geometry":{"coordinates":[76.65938195391948,21.942292968927006],"type":"Point"},"properties":{"name":"Point 1"},"type":"Feature"}],"type":"FeatureCollection"}
   */
  features: FeatureCollection;
}

/** Sort */
export interface Sort {
  /** Name */
  name: string;
  /** @default "asc" */
  order?: SortOrder;
}

/** SpectralGraph */
export interface SpectralGraph {
  /**
   * Geometry
   * @example {"coordinates":[76.65938195391948,21.942292968927006],"type":"Point"}
   */
  geometry: Point | Polygon;
  /**
   * Data
   * @example {"2023-12-30":{"B01":1466,"B02":1644,"B03":1284,"B04":280,"B05":282,"B06":249,"B07":253,"B08":226,"B09":258,"B11":243,"B12":229,"B8A":270,"SCL":6}}
   */
  data: Record<string, Record<string, number>>;
}

/** SpectralGraphGenerateModel */
export interface SpectralGraphGenerateModel {
  /**
   * Geometry
   * @example {"coordinates":[23.000619930059514,2.1699513782342024],"type":"Point"}
   */
  geometry: Point | Polygon;
  /**
   * Time
   * is optional
   * @example "1994-12-30"
   */
  time: string | null;
}

/** SpectralSignatureModel */
export interface SpectralSignatureModel {
  /** Point Model */
  point: Point;
  /** Time */
  time?: string | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VisualizationCreateModel */
export interface VisualizationCreateModel {
  /** Index Name */
  index_name?: string | null;
  /** Index Id */
  index_id?: string | null;
  /** Expression */
  expression?: string | null;
  /** @example "preset" */
  type: VisualizationType;
  /**
   * Src Asset Ids
   * @example ["e3a671ad-5381-4413-8c1c-bc4e1ccaff45","90d63531-5f54-4704-a4b0-7bb92ae08f23"]
   */
  src_asset_ids: string[];
  /** Resolution */
  resolution?: number | null;
}

/** VisualizationCreateModelV2 */
export interface VisualizationCreateModelV2 {
  /** Index Id */
  index_id?: string | null;
  /**
   * Src Asset Ids
   * @example ["e3a671ad-5381-4413-8c1c-bc4e1ccaff45","90d63531-5f54-4704-a4b0-7bb92ae08f23"]
   */
  src_asset_ids: string[];
  /** Resolution */
  resolution?: number | null;
}

/** VisualizationDetailModel */
export interface VisualizationDetailModel {
  /** Id */
  id: string;
  /** Aoi Id */
  aoi_id: string;
  /** User Id */
  user_id: string;
  /** Tenant Id */
  tenant_id: string;
  /** Index Name */
  index_name: string;
  /** Index Id */
  index_id?: string | null;
  /** Expression */
  expression: string;
  expression_type: ExpressionType;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  type: VisualizationType;
  /** Rescale */
  rescale?: any[] | null;
  /** Assets */
  assets: AssetReadModel[];
  /** Progress */
  progress: number;
  /** Enum which indicates the status of Visualization */
  status: CoreVisualizationVisualizationStatus;
  metadata?: VisualizationMetadata | null;
}

/** VisualizationDetailModelV2 */
export interface VisualizationDetailModelV2 {
  /** Id */
  id: string;
  /** Aoi Id */
  aoi_id: string;
  /** User Id */
  user_id: string;
  /** Index Name */
  index_name: string;
  /** Index Id */
  index_id?: string | null;
  /** Expression */
  expression: string;
  expression_type: ExpressionType;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
  type: VisualizationType;
  /** Rescale */
  rescale?: any[] | null;
  /** Assets */
  assets: AssetReadModel[];
  /** Progress */
  progress: number;
  /** Enum which indicates the status of Visualization */
  status: CoreVisualizationVisualizationStatus;
  metadata?: VisualizationMetadata | null;
}

/** VisualizationListResponseModel */
export interface VisualizationListResponseModel {
  /** Visualization */
  visualization: VisualizationDetailModel[];
  pagination: PaginationModel;
}

/** VisualizationMetadata */
export interface VisualizationMetadata {
  /**
   * Legend
   * @example {"2024-05-06":[{"area":50,"color":"#2b83ba","label":"Very Low","max":51,"min":0,"percentage":5},{"area":100,"color":"#abdda4","label":"Low","max":102,"min":51,"percentage":10},{"area":200,"color":"#fdae61","label":"Moderate","max":153,"min":102,"percentage":20},{"area":300,"color":"#f46d43","label":"High","max":204,"min":153,"percentage":30},{"area":350,"color":"#d73027","label":"Very High","max":255,"min":204,"percentage":35}],"2025-11-14":[{"area":60,"color":"#2b83ba","label":"Very Low","max":60,"min":0,"percentage":6},{"area":120,"color":"#abdda4","label":"Low","max":120,"min":60,"percentage":12},{"area":180,"color":"#fdae61","label":"Moderate","max":180,"min":120,"percentage":18},{"area":220,"color":"#f46d43","label":"High","max":220,"min":180,"percentage":22},{"area":350,"color":"#d73027","label":"Very High","max":255,"min":220,"percentage":35}]}
   */
  legend?: Record<string, LegendItem[]> | null;
}

/** VisualizationUpdateModel */
export interface VisualizationUpdateModel {
  /** Asset Ids */
  asset_ids: string[];
  /** Resolution */
  resolution?: number | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
* @title Atlas
* @version 1.0.0
* @contact Pixxel
 <support@pixxel.co.in> (https://pixxel.space/)
*  
* This service manages the lifecycle of AOI (Area of Interest)
*/
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  health = {
    /**
     * @description Service health endpoint
     *
     * @tags Generic
     * @name HealthHealthGet
     * @summary Health
     * @request GET:/health
     */
    healthHealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  ping = {
    /**
     * @description Service health endpoint
     *
     * @tags Generic
     * @name PingPongPingGet
     * @summary Ping Pong
     * @request GET:/ping
     */
    pingPongPingGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/ping`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  metrics = {
    /**
     * No description
     *
     * @name MetricsMetricsGet
     * @summary Metrics
     * @request GET:/metrics
     */
    metricsMetricsGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/metrics`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  projId = {
    /**
     * @description Create AOI
     *
     * @tags AOI
     * @name CreateAoiProjIdAoiPost
     * @summary Create Aoi
     * @request POST:/{proj_id}/aoi
     * @deprecated
     */
    createAoiProjIdAoiPost: (
      projId: string,
      data: AOICreateModel,
      params: RequestParams = {},
    ) =>
      this.request<
        AOIReadModel,
        ErrorMessageAOIAlreadyExists | HTTPValidationError
      >({
        path: `/${projId}/aoi`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all the AOIs inside project with proj_id
     *
     * @tags AOI
     * @name ListAoisProjIdAoiGet
     * @summary List Aois
     * @request GET:/{proj_id}/aoi
     * @deprecated
     */
    listAoisProjIdAoiGet: (
      projId: string,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AOIReadModel[],
        ErrorMessageAOINotFound | HTTPValidationError
      >({
        path: `/${projId}/aoi`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get specific AOI with name or aoi ID
     *
     * @tags AOI
     * @name GetAoiProjIdAoiNameGet
     * @summary Get Aoi
     * @request GET:/{proj_id}/aoi/{name}
     * @deprecated
     */
    getAoiProjIdAoiNameGet: (
      projId: string,
      name: string,
      params: RequestParams = {},
    ) =>
      this.request<AOIReadModel, ErrorMessageAOINotFound | HTTPValidationError>(
        {
          path: `/${projId}/aoi/${name}`,
          method: "GET",
          format: "json",
          ...params,
        },
      ),

    /**
     * @description Update AOI using aoi_id inside project with proj_id
     *
     * @tags AOI
     * @name UpdateAoiProjIdAoiAoiIdPut
     * @summary Update Aoi
     * @request PUT:/{proj_id}/aoi/{aoi_id}
     * @deprecated
     */
    updateAoiProjIdAoiAoiIdPut: (
      aoiId: string,
      projId: string,
      data: AOIUpdateModel,
      params: RequestParams = {},
    ) =>
      this.request<AOIReadModel, ErrorMessageAOINotFound | HTTPValidationError>(
        {
          path: `/${projId}/aoi/${aoiId}`,
          method: "PUT",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description Delete AOI using aoi_id inside project with proj_id
     *
     * @tags AOI
     * @name DeleteAoiProjIdAoiAoiIdDelete
     * @summary Delete Aoi
     * @request DELETE:/{proj_id}/aoi/{aoi_id}
     * @deprecated
     */
    deleteAoiProjIdAoiAoiIdDelete: (
      projId: string,
      aoiId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorMessageAOINotFound | HTTPValidationError>({
        path: `/${projId}/aoi/${aoiId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  aoiId = {
    /**
     * @description Create layer
     *
     * @tags Layer
     * @name CreateLayerAoiIdLayerPost
     * @summary Create Layer
     * @request POST:/{aoi_id}/layer
     */
    createLayerAoiIdLayerPost: (
      aoiId: string,
      data: LayerCreateModel,
      params: RequestParams = {},
    ) =>
      this.request<
        LayerReadModel,
        | ErrorMessageAOINotFound
        | ErrorMessageLayerAlreadyExists
        | HTTPValidationError
      >({
        path: `/${aoiId}/layer`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List layers inside an aoi
     *
     * @tags Layer
     * @name ListLayersAoiIdLayerGet
     * @summary List Layers
     * @request GET:/{aoi_id}/layer
     */
    listLayersAoiIdLayerGet: (
      aoiId: string,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        LayerReadModel[],
        ErrorMessageLayerNotFound | HTTPValidationError
      >({
        path: `/${aoiId}/layer`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create layer
     *
     * @tags Layer
     * @name GenerateLayerAoiIdLayerGeneratePost
     * @summary Generate Layer
     * @request POST:/{aoi_id}/layer/generate
     */
    generateLayerAoiIdLayerGeneratePost: (
      aoiId: string,
      data: LayerGenerateModel,
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | ErrorMessageAOINotFound
        | ErrorMessageLayerAlreadyExists
        | HTTPValidationError
      >({
        path: `/${aoiId}/layer/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get specific layer inside an aoi
     *
     * @tags Layer
     * @name GetLayerAoiIdLayerLayerIdGet
     * @summary Get Layer
     * @request GET:/{aoi_id}/layer/{layer_id}
     */
    getLayerAoiIdLayerLayerIdGet: (
      aoiId: string,
      layerId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        LayerReadModel,
        ErrorMessageLayerNotFound | HTTPValidationError
      >({
        path: `/${aoiId}/layer/${layerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update layer inside an aoi
     *
     * @tags Layer
     * @name UpdateLayerAoiIdLayerLayerIdPut
     * @summary Update Layer
     * @request PUT:/{aoi_id}/layer/{layer_id}
     */
    updateLayerAoiIdLayerLayerIdPut: (
      aoiId: string,
      layerId: string,
      data: LayerUpdateModel,
      params: RequestParams = {},
    ) =>
      this.request<
        LayerReadModel,
        ErrorMessageLayerNotFound | HTTPValidationError
      >({
        path: `/${aoiId}/layer/${layerId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete layer inside an aoi
     *
     * @tags Layer
     * @name DeleteLayerAoiIdLayerLayerIdDelete
     * @summary Delete Layer
     * @request DELETE:/{aoi_id}/layer/{layer_id}
     */
    deleteLayerAoiIdLayerLayerIdDelete: (
      aoiId: string,
      layerId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorMessageLayerNotFound | HTTPValidationError>({
        path: `/${aoiId}/layer/${layerId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Update layer inside an aoi
     *
     * @tags Layer
     * @name DownloadLayerAoiIdLayerLayerIdDownloadPost
     * @summary Download Layer
     * @request POST:/{aoi_id}/layer/{layer_id}/download
     * @deprecated
     */
    downloadLayerAoiIdLayerLayerIdDownloadPost: (
      aoiId: string,
      layerId: string,
      query: {
        /** Date */
        date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorMessageLayerNotFound | HTTPValidationError>({
        path: `/${aoiId}/layer/${layerId}/download`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description List assets inside an aoi
     *
     * @tags Asset
     * @name ListAssetsAoiIdAssetsGet
     * @summary List Assets
     * @request GET:/{aoi_id}/assets
     */
    listAssetsAoiIdAssetsGet: (
      aoiId: string,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 5000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AssetReadModel[],
        ErrorMessageAssetNotFound | HTTPValidationError
      >({
        path: `/${aoiId}/assets`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get specific asset inside an aoi
     *
     * @tags Asset
     * @name GetAssetAoiIdAssetsAssetIdGet
     * @summary Get Asset
     * @request GET:/{aoi_id}/assets/{asset_id}
     */
    getAssetAoiIdAssetsAssetIdGet: (
      aoiId: string,
      assetId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AssetReadModel,
        ErrorMessageAssetNotFound | HTTPValidationError
      >({
        path: `/${aoiId}/assets/${assetId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name DownloadAssetByIdAoiIdAssetsAssetIdDownloadGet
     * @summary Download Asset By Id
     * @request GET:/{aoi_id}/assets/{asset_id}/download
     */
    downloadAssetByIdAoiIdAssetsAssetIdDownloadGet: (
      aoiId: string,
      assetId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorMessageAssetNotFound | HTTPValidationError>({
        path: `/${aoiId}/assets/${assetId}/download`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name DownloadAssetAoiIdAssetsDownloadPost
     * @summary Download Asset
     * @request POST:/{aoi_id}/assets/download
     * @deprecated
     */
    downloadAssetAoiIdAssetsDownloadPost: (
      aoiId: string,
      data: AssetDownloadModel,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorMessageAssetNotFound | HTTPValidationError>({
        path: `/${aoiId}/assets/download`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate Spectral Signature for a given AOI and point
     *
     * @tags AOI
     * @name GenerateSpectralSignatureAoiIdSignaturePost
     * @summary Generate Spectral Signature
     * @request POST:/{aoi_id}/signature
     */
    generateSpectralSignatureAoiIdSignaturePost: (
      aoiId: string,
      data: SpectralSignatureModel,
      params: RequestParams = {},
    ) =>
      this.request<
        SignatureReadModel,
        ErrorMessageAOINotFound | HTTPValidationError
      >({
        path: `/${aoiId}/signature`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  v2 = {
    /**
     * @description List assets inside an aoi
     *
     * @tags Asset
     * @name ListAssetsV2AoisAoiIdAssetsGet
     * @summary List Assets
     * @request GET:/v2/aois/{aoi_id}/assets
     */
    listAssetsV2AoisAoiIdAssetsGet: (
      aoiId: string,
      query?: {
        /**
         * Offset
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @default 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetListResponseModel, ErrorSchema | HTTPValidationError>({
        path: `/v2/aois/${aoiId}/assets`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create Index
     *
     * @tags Index
     * @name CreateIndexV2IndicesPost
     * @summary Create Index
     * @request POST:/v2/indices
     */
    createIndexV2IndicesPost: (
      data: IndexCreateModel,
      params: RequestParams = {},
    ) =>
      this.request<IndexReadModel, ErrorSchema | HTTPValidationError>({
        path: `/v2/indices`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all the Indices for a user
     *
     * @tags Index
     * @name ListIndicesV2IndicesGet
     * @summary List Indices
     * @request GET:/v2/indices
     */
    listIndicesV2IndicesGet: (
      query?: {
        /**
         * Offset
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
        /** Satellite Id */
        satellite_id?: string | null;
        /** Type */
        type?: string | null;
        /** Expression Type */
        expression_type?: string | null;
        /** Index Ids */
        index_ids?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<IndicesListResponseModel, HTTPValidationError | ErrorSchema>(
        {
          path: `/v2/indices`,
          method: "GET",
          query: query,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags All_AOI
     * @name ListAoisV2AoisGet
     * @summary List Aois
     * @request GET:/v2/aois
     */
    listAoisV2AoisGet: (
      data: string[] | null,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 1000
         */
        limit?: number;
        /** Created At */
        created_at?: string | null;
        /** Updated At */
        updated_at?: string | null;
        /** Aoi Id */
        aoi_id?: string | null;
        /** Aoi Name */
        aoi_name?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AOIListResponseModel,
        ErrorMessageAOINotFound | HTTPValidationError
      >({
        path: `/v2/aois`,
        method: "GET",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create AOI
     *
     * @tags All_AOI
     * @name CreateAoiV2AoisPost
     * @summary Create Aoi
     * @request POST:/v2/aois
     */
    createAoiV2AoisPost: (data: AOICreateModelV2, params: RequestParams = {}) =>
      this.request<
        AOIReadModel,
        ErrorMessageAOIAlreadyExists | HTTPValidationError
      >({
        path: `/v2/aois`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visualization
     * @name ListVisualizationsV2AoisAoiIdVisualizationsGet
     * @summary List Visualizations
     * @request GET:/v2/aois/{aoi_id}/visualizations
     */
    listVisualizationsV2AoisAoiIdVisualizationsGet: (
      aoiId: string,
      query?: {
        /**
         * Offset
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
        /** Type */
        type?: string | null;
        /** User Id */
        user_id?: string | null;
        /** Index Id */
        index_id?: string | null;
        /** Expression Type */
        expression_type?: string | null;
        /** Visualization Id */
        visualization_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        VisualizationListResponseModel,
        ErrorSchema | HTTPValidationError
      >({
        path: `/v2/aois/${aoiId}/visualizations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visualization
     * @name CreateVisualizationV2AoisAoiIdVisualizationsPost
     * @summary Create Visualization
     * @request POST:/v2/aois/{aoi_id}/visualizations
     */
    createVisualizationV2AoisAoiIdVisualizationsPost: (
      aoiId: string,
      data: VisualizationCreateModelV2,
      params: RequestParams = {},
    ) =>
      this.request<
        VisualizationDetailModelV2,
        ErrorSchema | HTTPValidationError
      >({
        path: `/v2/aois/${aoiId}/visualizations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  indices = {
    /**
     * @description Create Index
     *
     * @tags Index
     * @name CreateIndexIndicesPost
     * @summary Create Index
     * @request POST:/indices
     */
    createIndexIndicesPost: (
      data: IndexCreateModelV1,
      params: RequestParams = {},
    ) =>
      this.request<
        IndexReadModelV1,
        ErrorMessageIndexAlreadyExists | HTTPValidationError
      >({
        path: `/indices`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all the Indices for a user
     *
     * @tags Index
     * @name ListIndicesIndicesGet
     * @summary List Indices
     * @request GET:/indices
     */
    listIndicesIndicesGet: (
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        IndexReadModelV1[],
        ErrorMessageIndicesNotFound | HTTPValidationError
      >({
        path: `/indices`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get index with index id or name
     *
     * @tags Index
     * @name GetIndexIndicesIndexIdGet
     * @summary Get Index
     * @request GET:/indices/{index_id}
     */
    getIndexIndicesIndexIdGet: (indexId: string, params: RequestParams = {}) =>
      this.request<
        IndexReadModelV1,
        ErrorMessageIndexNotFound | HTTPValidationError
      >({
        path: `/indices/${indexId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete Index using index_id
     *
     * @tags Index
     * @name DeleteIndexIndicesIndexIdDelete
     * @summary Delete Index
     * @request DELETE:/indices/{index_id}
     */
    deleteIndexIndicesIndexIdDelete: (
      indexId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorMessageIndexNotFound | HTTPValidationError>({
        path: `/indices/${indexId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  aoi = {
    /**
     * No description
     *
     * @tags All_AOI
     * @name ListAoisAoiGet
     * @summary List Aois
     * @request GET:/aoi
     */
    listAoisAoiGet: (
      query: {
        /** Org Id */
        org_id: string;
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 1000
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AOIReadModel[],
        ErrorMessageAOINotFound | HTTPValidationError
      >({
        path: `/aoi`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags All_AOI
     * @name GetAoiAoiAoiIdGet
     * @summary Get Aoi
     * @request GET:/aoi/{aoi_id}
     */
    getAoiAoiAoiIdGet: (aoiId: string, params: RequestParams = {}) =>
      this.request<AOIReadModel, ErrorMessageAOINotFound | HTTPValidationError>(
        {
          path: `/aoi/${aoiId}`,
          method: "GET",
          format: "json",
          ...params,
        },
      ),

    /**
     * @description Update AOI using aoi_id inside project with project_id
     *
     * @tags All_AOI
     * @name UpdateAoiAoiAoiIdPut
     * @summary Update Aoi
     * @request PUT:/aoi/{aoi_id}
     */
    updateAoiAoiAoiIdPut: (
      aoiId: string,
      data: AOIUpdateModelV2,
      params: RequestParams = {},
    ) =>
      this.request<AOIReadModel, ErrorMessageAOINotFound | HTTPValidationError>(
        {
          path: `/aoi/${aoiId}`,
          method: "PUT",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description Delete AOI using aoi_id inside project with proj_id
     *
     * @tags All_AOI
     * @name DeleteAoiAoiAoiIdDelete
     * @summary Delete Aoi
     * @request DELETE:/aoi/{aoi_id}
     */
    deleteAoiAoiAoiIdDelete: (aoiId: string, params: RequestParams = {}) =>
      this.request<any, ErrorMessageAOINotFound | HTTPValidationError>({
        path: `/aoi/${aoiId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags All_AOI
     * @name SearchAoisAoiSearchPost
     * @summary Search Aois
     * @request POST:/aoi/search
     */
    searchAoisAoiSearchPost: (data: RQLQuery, params: RequestParams = {}) =>
      this.request<AOIListResponseModel, ErrorSchema | HTTPValidationError>({
        path: `/aoi/search`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  aois = {
    /**
     * No description
     *
     * @tags downloads
     * @name GetDownloadStatusAoisAoiIdDownloadsDownloadIdGet
     * @summary Get Download Status
     * @request GET:/aois/{aoi_id}/downloads/{download_id}
     */
    getDownloadStatusAoisAoiIdDownloadsDownloadIdGet: (
      aoiId: string,
      downloadId: string,
      params: RequestParams = {},
    ) =>
      this.request<DownloadReadModel, ErrorSchema | HTTPValidationError>({
        path: `/aois/${aoiId}/downloads/${downloadId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags downloads
     * @name CreateDownloadRequestAoisAoiIdDownloadsPost
     * @summary Create Download Request
     * @request POST:/aois/{aoi_id}/downloads
     */
    createDownloadRequestAoisAoiIdDownloadsPost: (
      aoiId: string,
      data: DownloadCreateModel,
      params: RequestParams = {},
    ) =>
      this.request<
        DownloadReadModel,
        ErrorSchema | ErrorMessageAssetNotFound | HTTPValidationError
      >({
        path: `/aois/${aoiId}/downloads`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visualization
     * @name ListVisualizationsAoisAoiIdVisualizationsGet
     * @summary List Visualizations
     * @request GET:/aois/{aoi_id}/visualizations
     */
    listVisualizationsAoisAoiIdVisualizationsGet: (
      aoiId: string,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        VisualizationDetailModel[],
        ErrorSchema | HTTPValidationError
      >({
        path: `/aois/${aoiId}/visualizations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visualization
     * @name CreateVisualizationAoisAoiIdVisualizationsPost
     * @summary Create Visualization
     * @request POST:/aois/{aoi_id}/visualizations
     * @deprecated
     */
    createVisualizationAoisAoiIdVisualizationsPost: (
      aoiId: string,
      data: VisualizationCreateModel,
      params: RequestParams = {},
    ) =>
      this.request<VisualizationDetailModel, ErrorSchema | HTTPValidationError>(
        {
          path: `/aois/${aoiId}/visualizations`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Visualization
     * @name UpdateVisualizationAoisAoiIdVisualizationsVisualizationIdPatch
     * @summary Update Visualization
     * @request PATCH:/aois/{aoi_id}/visualizations/{visualization_id}
     */
    updateVisualizationAoisAoiIdVisualizationsVisualizationIdPatch: (
      aoiId: string,
      visualizationId: string,
      data: VisualizationUpdateModel,
      params: RequestParams = {},
    ) =>
      this.request<VisualizationDetailModel, ErrorSchema | HTTPValidationError>(
        {
          path: `/aois/${aoiId}/visualizations/${visualizationId}`,
          method: "PATCH",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Visualization
     * @name GetVisualizationAoisAoiIdVisualizationsVisualizationIdGet
     * @summary Get Visualization
     * @request GET:/aois/{aoi_id}/visualizations/{visualization_id}
     */
    getVisualizationAoisAoiIdVisualizationsVisualizationIdGet: (
      aoiId: string,
      visualizationId: string,
      params: RequestParams = {},
    ) =>
      this.request<VisualizationDetailModel, ErrorSchema | HTTPValidationError>(
        {
          path: `/aois/${aoiId}/visualizations/${visualizationId}`,
          method: "GET",
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Signature
     * @name GetSignatureDetailsAoisAoiIdSignaturesSignatureIdGet
     * @summary Get Signature Details
     * @request GET:/aois/{aoi_id}/signatures/{signature_id}
     */
    getSignatureDetailsAoisAoiIdSignaturesSignatureIdGet: (
      aoiId: string,
      signatureId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        SignatureDetailModel,
        ErrorMessageAOINotFound | HTTPValidationError
      >({
        path: `/aois/${aoiId}/signatures/${signatureId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Signature
     * @name UpdateSignatureAoisAoiIdSignaturesSignatureIdPut
     * @summary Update Signature
     * @request PUT:/aois/{aoi_id}/signatures/{signature_id}
     */
    updateSignatureAoisAoiIdSignaturesSignatureIdPut: (
      aoiId: string,
      signatureId: string,
      data: SignatureCreateModel,
      params: RequestParams = {},
    ) =>
      this.request<SignatureDetailModel, HTTPValidationError>({
        path: `/aois/${aoiId}/signatures/${signatureId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Signature
     * @name UpdateSignaturePropertiesAoisAoiIdSignaturesSignatureIdPatch
     * @summary Update Signature Properties
     * @request PATCH:/aois/{aoi_id}/signatures/{signature_id}
     */
    updateSignaturePropertiesAoisAoiIdSignaturesSignatureIdPatch: (
      aoiId: string,
      signatureId: string,
      data: SignatureUpdateModel,
      params: RequestParams = {},
    ) =>
      this.request<SignatureDetailModel, HTTPValidationError>({
        path: `/aois/${aoiId}/signatures/${signatureId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Signature
     * @name DeleteSignatureAoisAoiIdSignaturesSignatureIdDelete
     * @summary Delete Signature
     * @request DELETE:/aois/{aoi_id}/signatures/{signature_id}
     */
    deleteSignatureAoisAoiIdSignaturesSignatureIdDelete: (
      aoiId: string,
      signatureId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/aois/${aoiId}/signatures/${signatureId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Signature
     * @name ListSignaturesAoisAoiIdSignaturesGet
     * @summary List Signatures
     * @request GET:/aois/{aoi_id}/signatures
     */
    listSignaturesAoisAoiIdSignaturesGet: (
      aoiId: string,
      params: RequestParams = {},
    ) =>
      this.request<ListSignatureModel, void | HTTPValidationError>({
        path: `/aois/${aoiId}/signatures`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Signature
     * @name CreateSignatureAoisAoiIdSignaturesPost
     * @summary Create Signature
     * @request POST:/aois/{aoi_id}/signatures
     */
    createSignatureAoisAoiIdSignaturesPost: (
      aoiId: string,
      data: SignatureCreateModel,
      params: RequestParams = {},
    ) =>
      this.request<SignatureDetailModel, HTTPValidationError>({
        path: `/aois/${aoiId}/signatures`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Signature
     * @name GenerateSpectralGraphAoisAoiIdSignaturesGenerateSpectralGraphPost
     * @summary Generate Spectral Graph
     * @request POST:/aois/{aoi_id}/signatures/generate_spectral_graph
     */
    generateSpectralGraphAoisAoiIdSignaturesGenerateSpectralGraphPost: (
      aoiId: string,
      data: SpectralGraphGenerateModel,
      params: RequestParams = {},
    ) =>
      this.request<SpectralGraph, HTTPValidationError>({
        path: `/aois/${aoiId}/signatures/generate_spectral_graph`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  stac = {
    /**
     * No description
     *
     * @tags Stac
     * @name GetStacItemStacCollectionsAoiIdItemsItemIdGet
     * @summary Get Stac Item
     * @request GET:/stac/collections/{aoi_id}/items/{item_id}
     */
    getStacItemStacCollectionsAoiIdItemsItemIdGet: (
      aoiId: string,
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.request<Item, ErrorSchema | HTTPValidationError>({
        path: `/stac/collections/${aoiId}/items/${itemId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  geometry = {
    /**
     * @description Convert various geometry file formats to GeoJSON FeatureCollection. Supports the following formats: - KML (.kml) - KMZ (.kmz) - GeoJSON (.geojson, .json) - ZIP Shapefile (.zip containing .shp files) - WKT (.wkt) Args: file: Uploaded geometry file allow_multipolygon: Allow MultiPolygon geometries in output (default: False) geometry: Geometry processing instance (injected) Returns: GeoJSON FeatureCollection containing the converted geometries Raises: HTTPException: If a file format is unsupported or processing fails
     *
     * @tags Geometry
     * @name ConvertGeometryFileGeometryPost
     * @summary Convert Geometry File
     * @request POST:/geometry
     */
    convertGeometryFileGeometryPost: (
      data: BodyConvertGeometryFileGeometryPost,
      query?: {
        /**
         * Allow Multipolygon
         * Allow MultiPolygon geometries in the output
         * @default true
         */
        allow_multipolygon?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, ErrorSchema | HTTPValidationError>({
        path: `/geometry`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
}
